import { AutoTradeButton } from '@library/components/buttons';
import { InGameButton } from '@library/components/buttons/InGameButton';
import type { OddsType } from '@library/types/projection';
import { ProjectionInput } from '@library/components/inputs';
import { classNames } from '@library/utils';

export interface ProjectionInputCellProps {
  afx?: boolean;
  autoTrade?: boolean;
  autoTradeDisabled: boolean;
  className?: string;
  disabled?: boolean;
  inGame?: boolean;
  inGameDisabled?: boolean;
  initialValue?: number | '';
  inputClassName?: string;
  isInvalidProjectionValue?: boolean;
  isCommunityPlay?: boolean;
  isPromo?: boolean;
  onAutoTradeChange?: () => void;
  onInGameChange?: () => void;
  onChange: (value: string) => void;
  oddsType: OddsType;
  optIn?: boolean;
  projectionId: string;
  value: number | '';
}

export const ProjectionInputCell = ({
  afx = false,
  autoTrade = false,
  autoTradeDisabled,
  className = '',
  disabled = false,
  isCommunityPlay = false,
  inGame = false,
  inGameDisabled = autoTradeDisabled,
  initialValue = '',
  inputClassName = '',
  isInvalidProjectionValue = false,
  isPromo = false,
  onAutoTradeChange = () => {},
  onInGameChange = () => {},
  onChange,
  oddsType,
  optIn = false,
  projectionId,
  value
}: ProjectionInputCellProps) => {
  const isValueChanged = initialValue !== value;

  return (
    <td
      className={classNames(
        'flex min-w-44 items-center justify-center',
        className || 'py-4'
      )}
    >
      <ProjectionInput
        className={classNames(
          'rounded-l-md disabled:cursor-not-allowed',
          isInvalidProjectionValue
            ? 'border-roses focus:border-roses'
            : 'focus:border-msJackson',
          !isInvalidProjectionValue && isValueChanged ? 'border-msJackson' : '',
          !isInvalidProjectionValue && !isValueChanged
            ? 'border-soFresh-140'
            : '',
          inputClassName
        )}
        disabled={disabled}
        id={`${projectionId}-player-modal-projectionValue`}
        isCommunityPlay={isCommunityPlay}
        isPromo={isPromo}
        oddsType={oddsType}
        optIn={optIn}
        onValueChange={onChange}
        value={value}
      />
      {afx && (
        <>
          <AutoTradeButton
            autoTrade={autoTrade}
            className="!rounded-none"
            disabled={autoTradeDisabled}
            onClick={onAutoTradeChange}
          />
          <InGameButton
            inGame={inGame}
            className="h-8 border-l-transparent focus:border-l"
            disabled={inGameDisabled}
            onClick={onInGameChange}
          />
        </>
      )}
    </td>
  );
};
